import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useGetUserCertificates = () => {
  const userCertificateService = useServices().userCertificateService;
  return useQuery({
    queryKey: ['userProfileCertificates'],
    queryFn: () => userCertificateService.getUserProfileCertificates(),
    refetchOnWindowFocus: false,
  });
};
